import { StoreState } from '../store'

export const getFirestoreInitialized = (state: StoreState) =>
	state.firebase.initialized
export const getFirestoreAuthError = (state: StoreState) =>
	state.firebase.authenticationError
export const getFirestoreAuthenticated = (state: StoreState) =>
	state.firebase.authenticated
